// custom history object to allow navigation outside react components
export const historyApp: { navigate: any, location: any } = {
    navigate: null,
    location: null
};